import React from 'react';
import AirlineDetailPage from '../components/AirlineDetailPage';
import { AMERICAN_AIRLINES } from '../data/airlinesData';

export default function AmericanAirlinesPage() {
  return <AirlineDetailPage airline={AMERICAN_AIRLINES} />;
}
